import { useTranslation } from "react-i18next";
import { Wallet } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminPageTitle } from "@/hooks/admin/useAdminPageTitle";

export default function FinanceDashboard() {
  const { t } = useTranslation("admin");
  useAdminPageTitle("Finances");

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="font-display text-2xl font-semibold text-stone-900">
          {t("nav.finances")}
        </h1>

        <div className="flex items-center justify-center rounded-xl border border-dashed border-stone-300 bg-white p-16">
          <div className="text-center">
            <Wallet className="mx-auto h-10 w-10 text-stone-300" />
            <p className="mt-3 text-sm font-medium text-stone-500">
              {t("placeholder.coming_soon")}
            </p>
            <p className="mt-1 text-xs text-stone-400">
              {t("placeholder.coming_soon_description")}
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
